import {Injectable} from "@angular/core";
import {Observable} from "rxjs";
import {HttpService} from "../http/http.service";
import {
  PageAdminInfo, PageCampusKeyword,
  PageFaq,
  PageGuide,
  PageHomeMemberPost,
  PageInstagram,
  PageMemberPost,
  PageMypageLink,

  PageSlider2,
  PageSlider2Item,
  PageStory,

  PartnerCategory,
  PartnerItem,
  PageSpaceBanner,
  PageSpaceFloorInfo,

  FaqCategory,
  FaqItem,
  PagePlan,
  SliderV2,
  HomeSection,
  About,
} from "./page";

@Injectable()
export class PageService {
  url = '/api/pages';
  memberPostUrl = `${this.url}/member-posts`;

  storiesUrl = `${this.url}/stories`;
  instagramUrl = `${this.url}/instagram`;
  adminInfosUrl = `${this.url}/admin-infos`;
  helpUrl = `${this.url}/help`;

  mypageLinkUrl = `${this.url}/mypage-links`;
  campusKeywordUrl = `${this.url}/campus-keyword`;

  sliderUrl = `${this.url}/sliders2`;
  bannerUrl = `${this.url}/top-banner`;
  homeMemberUrl = `${this.url}/members`;

  guideUrl =  '/api/guide';
  partnersUrl = '/api/partnership';
  spaceBannerUrl = `${this.url}/space-banner?location=`;
  spaceFloorInfoUrl = `${this.url}/space-info?location=`;
  applytProductsNoticeUrl = `${this.url}/membership/products`

  faqUrl = '/api/faq'
  planUrl = `${this.url}/plan`

  constructor(private httpService: HttpService) {
  }

  getSlider(): Observable<PageSlider2> {
    return this.httpService.get(this.sliderUrl)
      .map(res => res.json() as PageSlider2);
  }

  getSliderV2(): Observable<SliderV2.Res> {
    return this.httpService.get('/api/pages/v2/main/sliders')
      .map(res => res.json() as SliderV2.Res);
  }

  getHomeSection() : Observable<HomeSection.Res> {
    return this.httpService.get('/api/pages/v2/main/section')
      .map(res => res.json() as HomeSection.Res);
  }

  getAbout():  Observable<About.Res> {
    return this.httpService.get('/api/pages/v2/about')
      .map(res => res.json() as About.Res);
  }

  getBanner(): Observable<PageSlider2Item> {
    return this.httpService.get(this.bannerUrl)
      .map(res => res.json() as PageSlider2Item);
  }

  getMemberPost(): Observable<PageMemberPost> {
    return this.httpService.get(this.memberPostUrl)
      .map(res => res.json() as PageMemberPost);
  }

  getHomeMember(): Observable<PageHomeMemberPost> {
    return this.httpService.get(this.homeMemberUrl)
      .map(res => res.json() as PageHomeMemberPost);
  }

  getStories(): Observable<PageStory[]> {
    return this.httpService.get(this.storiesUrl)
      .map(res => res.json() as PageStory[]);
  }

  getInstagrams(): Observable<PageInstagram[]> {
    return this.httpService.get(this.instagramUrl)
      .map(res => res.json() as PageInstagram[]);
  }


  getAdminInfos(): Observable<PageAdminInfo[]> {
    return this.httpService.get(this.adminInfosUrl)
      .map(res => res.json() as PageAdminInfo[]);
  }


  getMypageLink(): Observable<PageMypageLink[]> {
    return this.httpService.get(this.mypageLinkUrl)
      .map(res => res.json() as PageMypageLink[]);
  }

  getCampusKeyword(): Observable<PageCampusKeyword> {
    return this.httpService.get(this.campusKeywordUrl)
      .map(res => res.json() as PageCampusKeyword);
  }

  // ___________________________________________________________________________
  getGuide(location): Observable<[PageGuide]> {
    return this.httpService.get(`${this.guideUrl}/list?location=${location}`)
      .map(res => res.json() as [PageGuide]);
  }
  getGuideDetail(id): Observable<PageGuide> {
    return this.httpService.get(`${this.guideUrl}/${id}`)
      .map(res => res.json() as PageGuide);
  }

  getPartnerCategory(): Promise<PartnerCategory[]> {
    return this.httpService.get(`${this.partnersUrl}/categories`)
      .map(res => res.json() as PartnerCategory[]).toPromise();
  }
  getPartner(id): Promise<PartnerItem[]> {
    return this.httpService.get(`${this.partnersUrl}/list?category=${id}`)
      .map(res => res.json() as PartnerItem[]).toPromise();
  }

  getSpaceBanner(location): Promise<PageSpaceBanner> {
    return this.httpService.get(`${this.spaceBannerUrl}${location}`)
      .map(res => res.json() as PageSpaceBanner).toPromise();
  }
  getSpaceFloorInfo(location): Promise<PageSpaceFloorInfo> {
    return this.httpService.get(`${this.spaceFloorInfoUrl}${location}`)
      .map(res => res.json() as PageSpaceFloorInfo).toPromise();
  }

  getPlan(location): Observable<PagePlan> {
    return this.httpService.get(`${this.planUrl}?location=${location}`)
      .map(res => res.json() as PagePlan);
  }

  getFaqCategory(location): Promise<FaqCategory[]> {
    return this.httpService.get(`${this.faqUrl}/categories?location=${location}`)
      .map(res => res.json() as FaqCategory[]).toPromise();
  }
  getFaq(id): Promise<FaqItem[]> {
    return this.httpService.get(`${this.faqUrl}/list?category=${id}`)
      .map(res => res.json() as FaqItem[]).toPromise();
  }
}



// WEBPACK FOOTER //
// ./src/app/service/page/page.service.ts